// extracted by mini-css-extract-plugin
export var csatScore = "_ks-5";
export var header = "_ks-1";
export var panelWrapper = "_ks-2";
export var postPreview = "_ks-3";
export var rightContent = "_ks-0";
export var wrappingText = "_ks-4";